import React from "react";
import useInView from "../hooks/useInView";

function Testimonials() {
    const [sectionRef, isInView] = useInView();

    return (
        <section className="py-16 bg-gray-50">
            <div
                ref={sectionRef}
                className={`max-w-7xl mx-auto px-4 fade-in-section ${
                    isInView ? "is-visible" : ""
                }`}
            >
                <h2 className="text-4xl font-bold text-center mb-12">
                    Müşteri Yorumları
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="bg-white p-6 rounded-lg shadow">
                        <div className="flex items-center mb-4">
                            <div>
                                <h4 className="font-bold">Ahmet Yılmaz</h4>
                                <p className="text-gray-600">İş İnsanı</p>
                            </div>
                        </div>
                        <p className="text-gray-600">
                            "Muhteşem bir deneyimdi. Profesyonel ekip ve
                            kusursuz hizmet. Kesinlikle tekrar tercih edeceğim."
                        </p>
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow">
                        <div className="flex items-center mb-4">
                            <div>
                                <h4 className="font-bold">Mert Çetin</h4>
                                <p className="text-gray-600">Yönetici</p>
                            </div>
                        </div>
                        <p className="text-gray-600">
                            "Lüks yatın konforu ve sunulan premium hizmetler
                            beklentilerimizin çok üzerindeydi. Gerçek bir VIP
                            deneyimi yaşadık."
                        </p>
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow">
                        <div className="flex items-center mb-4">
                            <div>
                                <h4 className="font-bold">Ayşe Kaya</h4>
                                <p className="text-gray-600">Mimar</p>
                            </div>
                        </div>
                        <p className="text-gray-600">
                            "Rezervasyon sürecinden tatilin sonuna kadar her şey
                            kusursuzdu. Yatın konforu ve temizliği üst
                            düzeydeydi."
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonials;
